import React from 'react'
import { Modal, Row, Button, Col } from 'react-bootstrap'
import { conRol, Rol } from '../Aliado'
import { SelectorPermisos } from './SelectorPermisos'
interface Props {
    rol: Rol
    title: string
    open: boolean
    add: (d: any) => void
    close: () => void
}
interface State {
    acciones: number[],
}
export default class EditarRol extends React.Component<Props, State> {
    con = conRol();
    state = { acciones: [] };
    componentDidMount() {
        this.con.detalle(this.props.rol.id, (rol: Rol) => {
            this.setState({ acciones: rol.acciones.map(d => { return d.id }) })
        });
    }
    render() {
        let { props: { close, open, title }, state: { acciones } } = this;
        return <Modal size='xl' animation centered show={open} onHide={close}>
            <Modal.Header closeButton>
                {title}
            </Modal.Header>
            <Modal.Body>
                <Row>
                    <Col md={12}>
                        <SelectorPermisos selecteds={acciones} Click={this.click.bind(this)} />
                    </Col>
                </Row>
            </Modal.Body>
            <Modal.Footer>
                <Button className="float-right" onClick={this.save.bind(this)} variant="primary">
                    <span className="fa fa-floppy-o" /> GUARDAR
                </Button>
            </Modal.Footer>
        </Modal >
    }
    click(id: number) {
        const { acciones } = this.state;
        if (acciones.every(p => p !== id)) this.setState({ acciones: [...acciones, id] });
        else this.setState({ acciones: acciones.filter(p => p !== id) });
    }
    save() {
        let { props: { rol: { id } }, state: { acciones } } = this;
        this.con.actualizar(id,
            { acciones }, data => {
                this.props.add(data)
                this.props.close()
            })
    }
}